export const VIEWER_REPORT_METER_MONTH_MODEL_LIST = 'VIEWER_REPORT_METER_MONTH_MODEL_LIST'
export const VIEWER_REPORT_METER_MONTH_SEARCH = 'VIEWER_REPORT_METER_MONTH_SEARCH'
export const VIEWER_REPORT_METER_MONTH_PAGINATION = 'VIEWER_REPORT_METER_MONTH_PAGINATION'
export const VIEWER_REPORT_METER_MONTH_DROP_DOWN_SEARCH_TYPE = 'VIEWER_REPORT_METER_MONTH_DROP_DOWN_SEARCH_TYPE'
export const VIEWER_REPORT_METER_MONTH_DROP_DOWN_SEARCH_SOURCE = 'VIEWER_REPORT_METER_MONTH_DROP_DOWN_SEARCH_SOURCE'

